import { Capacitor } from '@capacitor/core'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import ReactDOM from 'react-dom/client'
import App from './App'
import { logError } from './util/errorLogger'
import { restoreSessionFromHash } from './util/sessionRestorer'

// CapacitorUpdater is native-only; it throws on web and can cause white screen if called unconditionally.
try {
  if (Capacitor.getPlatform() !== 'web') {
    CapacitorUpdater.notifyAppReady()
  }
} catch (e) {
  console.warn('CapacitorUpdater.notifyAppReady failed (non-fatal):', e)
}

async function init() {
  // Restore session from URL hash when navigated from native app to web for payment.
  // Only acts when #session= is present; no-op on all other page loads.
  await restoreSessionFromHash()
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
init().then(() => {
  root.render(
    // <React.StrictMode>
    <App />,
    // </React.StrictMode>
  )
}).catch((e) => {
  void logError(e, { source: 'appInit' })
  root.render(<App />)
})